import { useState, useContext, useEffect, useRef } from "react";

//Components
import SingleDropDown from "./SingleDropDown";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { FormControl, Button, Modal } from "@material-ui/core";

//Contexts
import { IncidentsContext } from "../Contexts/IncidentsContext";
import { SetupContext } from "../Contexts/SetupContext";
import { INCIDENT_ACTIONS } from "../Actions/IncidentActions";

//Utils
import {
  formatNameFromPersonObj,
  parseObjectArrayIdString,
} from "../utils/utils";
import { MutationContext } from "../Contexts/MutationContext";
import { ModalHeader } from "./ModalHeader";
import clsx from "clsx";
import { styled } from "styled-components";
import UseOfForce from "./TicketAndWarning/UseOfForce";

import moment from "moment";

const StyledHeader = styled.h3`
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0;
  color: ${props => (props.nightMode ? "white" : "black")};
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  border: 1px solid grey;
  margin: 10px;
`;

const PassengerContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const RaceDataModal = ({
  raceModal,
  setRaceModal,
  classes,
  nightMode,
  handleReadyForApproval,
  incident,
  incidentPeople,
  userRoles,
  ticket,
  user,
  investigatingOfficerId,
  ...props
}) => {
  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);
  const { UPDATE_INCIDENT_TICKET, UPDATE_PERSON_PERSONAL_ATTRIBUTE_IN_PIS } =
    INCIDENT_ACTIONS;
  const { incidentDispatch } = useContext(IncidentsContext);
  const {
    updatePersonDob,
    updateTicketOperator,
    updatePersonGender,
    updateTicketPerceivedRace,
    updateTicketStop,
    updateTicketSearch,
    updateTicketUofInstance,
    updateTicketUofInstanceTypes,
    updateTicketUofInjuryDetails,
    updateTicketEvidence,
    updateTicketOutcome,
    updateTicketPassengerTicketSearch,
    updateTicketPassengerTicketEvidence,
    updateTicketPassengerTicketOutcome,
  } = useContext(MutationContext);
  const { setup } = useContext(SetupContext);
  const {
    reviewStatuses,
    genders,
    perceivedRaces,
    uofInstanceTypes: uofInstanceTypess,
    uofInjuryDetails: uofInjuryDetailss,
    ticketStopTypes,
    ticketSearchTypes,
    ticketEvidenceTypes,
    ticketOutcomeTypes,
    passengerTicketSearchTypes,
    passengerTicketEvidenceTypes,
    passengerTicketOutcomeTypes,
  } = setup.setupLists;

  const operator = incidentPeople?.find(p => p?.id === ticket?.operator?.id);
  const stateToMutation = {
    operator: "operatorId",
    perceivedRace: "perceivedRaceId",
    uofInstance: "uofInstanceId",
    uofInstanceTypes: "uofInstanceTypeIds",
    uofInjuryDetails: "uofInjuryDetailIds",
    dob: "dob",
    gender: "genderId",
    ticketStopType: "ticketStopTypeId",
    ticketSearchType: "ticketSearchTypeId",
    ticketEvidenceType: "ticketEvidenceTypeId",
    ticketOutcomeType: "ticketOutcomeTypeId",
    passengerTicketSearchType: "passengerTicketSearchTypeId",
    passengerTicketEvidenceType: "passengerTicketEvidenceTypeId",
    passengerTicketOutcomeType: "passengerTicketOutcomeTypeId",
  };

  useEffect(() => {
    if (inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, [inputLabel]);

  const personUpdater = event => {
    const name = event.target.name || null;
    const value = event.target.value;
    const fieldToUpdate = stateToMutation[name];
    switch (name) {
      case "gender":
        incidentDispatch({
          type: UPDATE_PERSON_PERSONAL_ATTRIBUTE_IN_PIS,
          payload: {
            personId: ticket?.operator?.id,
            property: name,
            value: value,
          },
        });
        updatePersonGender({
          variables: {
            input: {
              originatorId: user?.id,
              incidentId: incident?.id ? incident?.id : null,
              personId: ticket?.operator?.id,
              [fieldToUpdate]: value.id ? value.id : "",
            },
          },
        });
        return null;

      default:
        alert(
          `Name not found in handle function in TicketAndWarning.js: ${name}`
        );
        return null;
    }
  };
  const handlePersonDOBChange = (value, name, date) => {
    let fieldToUpdate = stateToMutation[name];
    let serverTimeFormat = "";
    const pis = incident?.personIncidentSpecifics?.find(
      pis => pis?.person?.id === ticket?.operator?.id
    );
    let payload = {
      personId: pis?.person?.id,
      property: name,
      value: serverTimeFormat,
    };
    if (!date) {
      incidentDispatch({
        type: UPDATE_PERSON_PERSONAL_ATTRIBUTE_IN_PIS,
        payload: payload,
      });
      updatePersonDob({
        variables: {
          input: {
            originatorId: user?.id,
            incidentId: incident?.id ? incident?.id : null,
            personId: pis?.person?.id,
            [fieldToUpdate]: serverTimeFormat,
          },
        },
      });
    } else if (date.isValid()) {
      serverTimeFormat = date.utc().format("YYYY-MM-DD HH:mm:ss UTC");
      payload.value = serverTimeFormat;
      incidentDispatch({
        type: UPDATE_PERSON_PERSONAL_ATTRIBUTE_IN_PIS,
        payload: payload,
      });
      updatePersonDob({
        variables: {
          input: {
            originatorId: user?.id,
            incidentId: incident?.id ? incident?.id : null,
            personId: pis?.person?.id,
            [fieldToUpdate]: serverTimeFormat,
          },
        },
      });
    }
  };

  const ticketUpdater = event => {
    const name = event.target.name || null;
    const value = event.target.value;
    const fieldToUpdate = stateToMutation[name];

    switch (name) {
      case "operator":
        incidentDispatch({
          type: UPDATE_INCIDENT_TICKET,
          payload: {
            incidentId: incident?.id ? incident?.id : incident?.uuid,
            ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
            property: name,
            value: value,
          },
        });
        updateTicketOperator({
          variables: {
            input: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              originatorId: user?.id,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              [fieldToUpdate]: value?.id ? value.id : "",
            },
          },
          context: { serializationKey: "incidentQueue" },
        });
        return null;
      case "perceivedRace":
        incidentDispatch({
          type: UPDATE_INCIDENT_TICKET,
          payload: {
            incidentId: incident?.id ? incident?.id : incident?.uuid,
            ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
            property: name,
            value: value,
          },
        });
        updateTicketPerceivedRace({
          variables: {
            input: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              originatorId: user?.id,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              [fieldToUpdate]: value?.id ? value.id : "",
            },
          },
          context: { serializationKey: "incidentQueue" },
        });
        return null;
      case "ticketStopType":
        incidentDispatch({
          type: UPDATE_INCIDENT_TICKET,
          payload: {
            incidentId: incident?.id ? incident?.id : incident?.uuid,
            ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
            property: name,
            value: value,
          },
        });
        updateTicketStop({
          variables: {
            input: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              originatorId: user?.id,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              [fieldToUpdate]: value?.id ? value.id : "",
            },
          },
          context: { serializationKey: "incidentQueue" },
        });
        return null;
      case "ticketSearchType":
        incidentDispatch({
          type: UPDATE_INCIDENT_TICKET,
          payload: {
            incidentId: incident?.id ? incident?.id : incident?.uuid,
            ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
            property: name,
            value: value,
          },
        });
        updateTicketSearch({
          variables: {
            input: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              originatorId: user?.id,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              [fieldToUpdate]: value?.id ? value.id : "",
            },
          },
          context: { serializationKey: "incidentQueue" },
        });
        return null;
      case "ticketEvidenceType":
        incidentDispatch({
          type: UPDATE_INCIDENT_TICKET,
          payload: {
            incidentId: incident?.id ? incident?.id : incident?.uuid,
            ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
            property: name,
            value: value,
          },
        });
        updateTicketEvidence({
          variables: {
            input: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              originatorId: user?.id,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              [fieldToUpdate]: value?.id ? value.id : "",
            },
          },
          context: { serializationKey: "incidentQueue" },
        });
        return null;
      case "ticketOutcomeType":
        incidentDispatch({
          type: UPDATE_INCIDENT_TICKET,
          payload: {
            incidentId: incident?.id ? incident?.id : incident?.uuid,
            ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
            property: name,
            value: value,
          },
        });
        updateTicketOutcome({
          variables: {
            input: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              originatorId: user?.id,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              [fieldToUpdate]: value?.id ? value.id : "",
            },
          },
          context: { serializationKey: "incidentQueue" },
        });
        return null;
      case "passengerTicketSearchType":
        incidentDispatch({
          type: UPDATE_INCIDENT_TICKET,
          payload: {
            incidentId: incident?.id ? incident?.id : incident?.uuid,
            ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
            property: name,
            value: value,
          },
        });
        updateTicketPassengerTicketSearch({
          variables: {
            input: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              originatorId: user?.id,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              [fieldToUpdate]: value?.id ? value.id : "",
            },
          },
          context: { serializationKey: "incidentQueue" },
        });
        return null;
      case "passengerTicketEvidenceType":
        incidentDispatch({
          type: UPDATE_INCIDENT_TICKET,
          payload: {
            incidentId: incident?.id ? incident?.id : incident?.uuid,
            ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
            property: name,
            value: value,
          },
        });
        updateTicketPassengerTicketEvidence({
          variables: {
            input: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              originatorId: user?.id,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              [fieldToUpdate]: value?.id ? value.id : "",
            },
          },
          context: { serializationKey: "incidentQueue" },
        });
        return null;
      case "passengerTicketOutcomeType":
        incidentDispatch({
          type: UPDATE_INCIDENT_TICKET,
          payload: {
            incidentId: incident?.id ? incident?.id : incident?.uuid,
            ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
            property: name,
            value: value,
          },
        });
        updateTicketPassengerTicketOutcome({
          variables: {
            input: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              originatorId: user?.id,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              [fieldToUpdate]: value?.id ? value.id : "",
            },
          },
          context: { serializationKey: "incidentQueue" },
        });
        return null;
      case "uofInstance":
        if (value?.name?.includes("None")) {
          //find the nones
          const noneInstanceType = uofInstanceTypess.find(
            ({ name }) => name === "None"
          );
          const noneInjuryDetail = uofInjuryDetailss.find(
            ({ name }) => name === "None"
          );
          incidentDispatch({
            type: UPDATE_INCIDENT_TICKET,
            payload: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              property: name,
              value: value,
            },
          });
          incidentDispatch({
            type: UPDATE_INCIDENT_TICKET,
            payload: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              property: "uofInstanceTypes",
              value: [noneInstanceType],
            },
          });
          incidentDispatch({
            type: UPDATE_INCIDENT_TICKET,
            payload: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              property: "uofInjuryDetails",
              value: [noneInjuryDetail],
            },
          });
          updateTicketUofInstance({
            variables: {
              input: {
                incidentId: incident.id ? incident.id : incident.uuid,
                originatorId: user?.id,
                officerId: investigatingOfficerId,
                ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
                [fieldToUpdate]: value.id ? value.id : value,
                uofInjuryDetailIds: noneInjuryDetail?.id,
                uofInstanceTypeIds: noneInstanceType?.id,
              },
            },
            context: { serializationKey: "incidentQueue" },
          });
        } else {
          incidentDispatch({
            type: UPDATE_INCIDENT_TICKET,
            payload: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              property: name,
              value: value,
            },
          });
          updateTicketUofInstance({
            variables: {
              input: {
                incidentId: incident?.id ? incident?.id : incident?.uuid,
                originatorId: user?.id,
                ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
                [fieldToUpdate]: value?.id ? value.id : "",
              },
            },
            context: { serializationKey: "incidentQueue" },
          });
        }
        return null;
      case "uofInstanceTypes":
        incidentDispatch({
          type: UPDATE_INCIDENT_TICKET,
          payload: {
            incidentId: incident?.id ? incident?.id : incident?.uuid,
            ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
            property: name,
            value: value,
          },
        });
        //removed officerId from these
        updateTicketUofInstanceTypes({
          variables: {
            input: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              originatorId: user?.id,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              [fieldToUpdate]: parseObjectArrayIdString(value),
            },
          },
          context: { serializationKey: "incidentQueue" },
        });
        return null;
      case "uofInjuryDetails":
        incidentDispatch({
          type: UPDATE_INCIDENT_TICKET,
          payload: {
            incidentId: incident?.id ? incident?.id : incident?.uuid,
            ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
            property: name,
            value: value,
          },
        });
        //removed officerId from these
        updateTicketUofInjuryDetails({
          variables: {
            input: {
              incidentId: incident?.id ? incident?.id : incident?.uuid,
              originatorId: user?.id,
              ticketId: ticket?.id ? ticket?.id : ticket?.uuid,
              [fieldToUpdate]: parseObjectArrayIdString(value),
            },
          },
          context: { serializationKey: "incidentQueue" },
        });
        return null;

      default:
        alert(
          `Name not found in handle function in TicketAndWarning.js: ${name}`
        );
        return null;
    }
  };

  const handleSubmit = () => {
    handleReadyForApproval({
      target: {
        name: "reviewStatus",
        value: reviewStatuses.find(
          status => status.name === "Ready for Approval"
        ),
      },
    });
    setRaceModal(false);
  };

  const handleCancel = () => {
    setRaceModal(false);
  };

  return (
    <Modal
      keepMounted={false}
      open={raceModal}
      onClose={() => {
        setRaceModal(false);
      }}
      className={classes.modal}
      style={{ maxWidth: "75%", width: "fit-content", margin: "auto" }}
      data-cy="narrative-template-race-tracking-modal"
      onKeyDown={e => {
        if (e.key === "Escape") {
          setRaceModal(false);
        }
      }}
      disablePortal={true}
    >
      <form
        onSubmit={handleSubmit}
        id={"tabs-wrapper"}
        style={{
          height: "fit-content",
          width: "fit-content",
          borderRadius: "5px",
        }}
        className={classes.tabRoot}
      >
        <ModalHeader
          headerName={"Race/UOF Tracking"}
          setModalOpen={setRaceModal}
          nightMode={nightMode}
          helpIconObjectName={""}
        />
        <div>
          <StyledHeader>Person Data Collection</StyledHeader>
          <FlexContainer>
            <SingleDropDown
              disabled={false}
              handleChange={e => ticketUpdater(e)}
              stateName={"operator"}
              value={ticket?.operator}
              options={incidentPeople}
              title={"Operator"}
              classStyle={clsx(
                classes.formControl,
                classes.fixedWidth,
                ticket?.operator ? {} : classes.vcvc_required
              )}
              inputLabel={inputLabel}
              labelWidth={labelWidth}
              nameFormatter={formatNameFromPersonObj}
              userRoles={userRoles}
              required={true}
              {...props}
            />
            {/* DOB */}
            <FormControl
              className={classes.formControl}
              style={{ marginRight: "4vw" }}
            >
              <KeyboardDatePicker
                required={true}
                clearable
                label="DOB"
                InputLabelProps={{ shrink: true }}
                // value={ticket?.operator?.personalAttribute?.dob ? moment.utc(ticket?.operator?.personalAttribute?.dob, "YYYY-MM-DD HH:mm:ss UTC").local() : null}
                value={
                  operator?.personalAttribute?.dob
                    ? moment
                        .utc(
                          operator?.personalAttribute?.dob,
                          "YYYY-MM-DD HH:mm:ss UTC"
                        )
                        .local()
                    : null
                }
                onChange={(date, value) =>
                  handlePersonDOBChange(value, "dob", date)
                }
                format="MM/DD/YYYY"
                style={{ width: "150px" }}
                disabled={false}
                className={
                  operator?.personalAttribute?.dob ? "" : classes.vcvc_required
                }
              />
            </FormControl>
            {/* Sex */}
            <SingleDropDown
              required={true}
              handleChange={personUpdater}
              stateName={"gender"}
              value={operator?.personalAttribute?.gender}
              options={genders}
              title={"Sex"}
              classStyle={clsx(
                classes.formControl,
                operator?.personalAttribute?.gender ? {} : classes.vcvc_required
              )}
              inputLabel={inputLabel}
              labelWidth={labelWidth}
              userRoles={userRoles}
              {...props}
            />
          </FlexContainer>
        </div>
        <br />
        <div>
          <StyledHeader>Ticket Data Collection</StyledHeader>
          <FlexContainer>
            <SingleDropDown
              required={true}
              disabled={false}
              handleChange={ticketUpdater}
              stateName={"perceivedRace"}
              value={ticket?.perceivedRace}
              options={perceivedRaces}
              title={"Perceived\xa0Race"}
              classStyle={clsx(
                classes.formControl,
                classes.fitHeight,
                classes.fixedWidth,
                ticket?.perceivedRace ? {} : classes.vcvc_required
              )}
              inputLabel={inputLabel}
              labelWidth={labelWidth}
              userRoles={userRoles}
              {...props}
            />
            <SingleDropDown
              required={true}
              disabled={false}
              handleChange={ticketUpdater}
              stateName={"ticketStopType"}
              value={ticket?.ticketStopType}
              options={ticketStopTypes}
              title={"Stop\xa0Based\xa0On"}
              classStyle={clsx(
                classes.formControl,
                classes.fitHeight,
                classes.fixedWidth,
                ticket?.ticketStopType ? {} : classes.vcvc_required
              )}
              inputLabel={inputLabel}
              labelWidth={labelWidth}
              userRoles={userRoles}
              {...props}
            />
            <PassengerContainer>
              <SingleDropDown
                required={true}
                disabled={false}
                handleChange={ticketUpdater}
                stateName={"ticketSearchType"}
                value={ticket?.ticketSearchType}
                options={ticketSearchTypes}
                title={"Search\xa0Based\xa0On"}
                classStyle={clsx(
                  classes.formControl,
                  classes.fixedWidth,
                  ticket?.ticketSearchType ? {} : classes.vcvc_required
                )}
                inputLabel={inputLabel}
                labelWidth={labelWidth}
                userRoles={userRoles}
                {...props}
              />
              <SingleDropDown
                disabled={false}
                handleChange={ticketUpdater}
                stateName={"passengerTicketSearchType"}
                value={ticket?.passengerTicketSearchType}
                options={passengerTicketSearchTypes}
                title={"Passenger\xa0Search\xa0Based\xa0On"}
                classStyle={clsx(classes.formControl, classes.fixedWidth)}
                inputLabel={inputLabel}
                labelWidth={labelWidth}
                userRoles={userRoles}
                {...props}
              />
            </PassengerContainer>
            <PassengerContainer>
              <SingleDropDown
                required={true}
                disabled={false}
                handleChange={ticketUpdater}
                stateName={"ticketEvidenceType"}
                value={ticket?.ticketEvidenceType}
                options={ticketEvidenceTypes}
                title={"Contraband/Evidence"}
                classStyle={clsx(
                  classes.formControl,
                  classes.fixedWidth,
                  ticket?.ticketEvidenceType ? {} : classes.vcvc_required
                )}
                inputLabel={inputLabel}
                labelWidth={labelWidth}
                userRoles={userRoles}
                {...props}
              />
              <SingleDropDown
                disabled={false}
                handleChange={ticketUpdater}
                stateName={"passengerTicketEvidenceType"}
                value={ticket?.passengerTicketEvidenceType}
                options={passengerTicketEvidenceTypes}
                title={"Passenger\xa0Contra./Evid."}
                classStyle={clsx(classes.formControl, classes.fixedWidth)}
                inputLabel={inputLabel}
                labelWidth={labelWidth}
                userRoles={userRoles}
                {...props}
              />
            </PassengerContainer>
            <PassengerContainer>
              <SingleDropDown
                required={true}
                disabled={false}
                handleChange={ticketUpdater}
                stateName={"ticketOutcomeType"}
                value={ticket?.ticketOutcomeType}
                options={ticketOutcomeTypes}
                title={"Outcome\xa0Of\xa0Stop"}
                classStyle={clsx(
                  classes.formControl,
                  classes.fixedWidth,
                  ticket?.ticketOutcomeType ? {} : classes.vcvc_required
                )}
                inputLabel={inputLabel}
                labelWidth={labelWidth}
                userRoles={userRoles}
                {...props}
              />
              <SingleDropDown
                disabled={false}
                handleChange={ticketUpdater}
                stateName={"passengerTicketOutcomeType"}
                value={ticket?.passengerTicketOutcomeType}
                options={passengerTicketOutcomeTypes}
                title={"Passenger\xa0Outcome\xa0Of\xa0Stop"}
                classStyle={clsx(classes.formControl, classes.fixedWidth)}
                inputLabel={inputLabel}
                labelWidth={labelWidth}
                userRoles={userRoles}
                {...props}
              />
            </PassengerContainer>
            {/* <UOFContainer>
              <SingleDropDown
                required={true}
                handleChange={(e) => ticketUpdater(e, true, false)}
                stateName={'uofInstance'}
                value={ticket?.uofInstance}
                options={uofInstances}
                title={"Use\xa0Of\xa0Force"}
                classStyle={clsx(classes.formControl, classes.fixedWidth, classes.spacingToRight, ticket?.uofInstance ? {} : classes.vcvc_required)}
                inputLabel={inputLabel}
                labelWidth={labelWidth}
                userRoles={userRoles}
                {...props}
              />
              <MultiDropDownObjects
                required={true}
                id={"uofInstanceTypes"}
                formStyle={clsx(classes.formControl, classes.spacingToRight, ticket?.uofInstanceTypes?.length > 0 ? {} : classes.vcvc_required)}
                labelStyle={classes.multiInputLabel}
                title={"Types\xa0Of\xa0Force"}
                selectStyle={null}
                chipsStyle={classes.chips}
                chipStyle={classes.chip}
                stateName={"uofInstanceTypes"}
                //this handleChange might have to change to a multiChange
                handleChange={(e) => ticketUpdater(e, true, false)}
                selectedValues={ticket?.uofInstanceTypes ? uofInstanceTypess?.filter(option => ticket?.uofInstanceTypes?.some(type => option.id === type?.id)) : []}
                options={uofInstanceTypess?.length > 0 ? uofInstanceTypess : []}
                userRoles={userRoles}
                {...props}
              />
              <MultiDropDownObjects
                required={true}
                id={"uofInjuryDetails"}
                formStyle={clsx(classes.formControl, classes.spacingToRight, ticket?.uofInjuryDetails?.length > 0 ? {} : classes.vcvc_required)}
                labelStyle={classes.multiInputLabel}
                title={"UOF\xa0Injuries"}
                selectStyle={null}
                chipsStyle={classes.chips}
                chipStyle={classes.chip}
                stateName={"uofInjuryDetails"}
                handleChange={(e) => ticketUpdater(e, true, false)}
                selectedValues={ticket?.uofInjuryDetails ? uofInjuryDetailss?.filter(option => ticket?.uofInjuryDetails?.some(type => option.id === type?.id)) : []}
                options={uofInjuryDetailss?.length > 0 ? uofInjuryDetailss : []}
                userRoles={userRoles}
                {...props}
              />
            </UOFContainer> */}
            <UseOfForce
              handleChange={ticketUpdater}
              uofInstance={ticket?.uofInstance}
              uofInstanceTypes={ticket?.uofInstanceTypes}
              uofInjuryDetails={ticket?.uofInjuryDetails}
              userRoles={userRoles}
              showValidation={true}
              {...props}
            />
          </FlexContainer>
        </div>
        <Button
          className={clsx(classes.buttonHover, classes.navBarButtons)}
          style={{ margin: "1em", width: "fit-content" }}
          variant="contained"
          type="submit"
        >
          OK
        </Button>
        <Button
          className={clsx(classes.buttonHover, classes.navBarButtons)}
          style={{ margin: "1em", width: "fit-content" }}
          variant="contained"
          type="button"
          onClick={handleCancel}
        >
          Cancel
        </Button>
      </form>
    </Modal>
  );
};

export default RaceDataModal;
